import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  isSuperAdmin : boolean = false;
  sharePointUrl = '';
  urbanPaceUrl = '';
  assetsUrl = '';
  @Input() fullWidth = false;
  public isOfficeManagerUser: boolean = false;

  constructor(
    private commonService: CommonService,
  ) { 
    // Blank constructor
  }

  ngOnInit(): void {
    this.sharePointUrl = environment.sharePointUrl;
    this.urbanPaceUrl = environment.urbanPaceUrl;
    this.assetsUrl = environment.assetsUrl;
    this.isSuperAdmin = this.commonService.isSuperAdminUser();
    this.isOfficeManagerUser = this.commonService.isOfficeManagerUser();
  }

}
